import { render, staticRenderFns } from "./SupplierMerchantContractPage.vue?vue&type=template&id=7858859f&scoped=true"
import script from "./SupplierMerchantContractPage.vue?vue&type=script&lang=js"
export * from "./SupplierMerchantContractPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7858859f",
  null
  
)

export default component.exports